import React from "react";
import "../LoaderWrapper/Loader.css";
import loader from "../../../src/Loader/loader.gif";

const LoaderWrapper: React.FC = () => {
  return (
    <div className="loader-container">
      <div className="background-blur"></div>
      <div className="loader-content">
        <img
          style={{ borderRadius: "50%", height: "100px" }}
          src={loader}
          alt="Loader GIF"
        />
      </div>
    </div>
  );
};

export default LoaderWrapper;
